import { Injectable } from '@angular/core';
import { Observable as __Observable, Observable } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import * as firebase from 'firebase/app';
import {GeoFirestore, GeoCollectionReference} from 'geofirestore';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  geoFirestore: GeoCollectionReference;

  constructor(private firestore: AngularFirestore) {
    const geofirestore = new GeoFirestore(firebase.firestore());
    this.geoFirestore = geofirestore.collection('locations');
   }

  //Adds GeoFire Data to Database
  setGeoLocation(location_id: string, cords: Array<number>){
    this.geoFirestore.doc(location_id)
      .set({coordinates: new firebase.firestore.GeoPoint(cords[0], cords[1])})
        .then(_ => {
          console.log('added')
        })
      .catch(err => {
        console.log(err)
      })
  //   return this.geoFirestore.add({ location_id: location_id,
  //         coordinates: new firebase.firestore.GeoPoint(cords[0], cords[1])
  //       })
  //         .then(_ => {
  //           console.log('added')
  //       })
  //         .catch(err => {
  //           console.log(err)
  // })
  }

 // Queries database for nearby locations
 getGeoLocation(radius: number, cords: Array<number>){
  return this.geoFirestore.near({
    center: new firebase.firestore.GeoPoint(cords[0], cords[1]),
    radius: radius
  }).get()
  .then(res => {
    return res.docs
  })
}


}
